




























































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {ParameterValue, ProductParameters, ServiceParameters} from "@/client";
import {getModule} from "vuex-module-decorators";
import DeploymentStore, {DeploymentModel} from "@/store/deployment";
import {VForm} from "vuetify/lib";

const deployments = getModule(DeploymentStore);

export type VForm = Vue & { validate: () => boolean }

@Component
export default class NewDeployment extends Vue {

    @Prop() public valid = false;
    @Prop() public message = '';
    @Prop() public error = null;

    public mounted() {
        if (!deployments.isInitialized) {
            deployments.initNewDeployment()
        }
        this.validateForm()
    }

    public form(): VForm {
        return this.$refs.form as VForm
    }

    public validateForm() {
        return this.valid = this.form().validate();
    }

    public canStartDeployment(): boolean {
        return this.valid && !!this.model.productModels.find(service => service.enabled)
    }

    public startDeployment() {
        if (!this.validateForm()) {
            this.message = "There are validation issues. Deployment cannot be started"
            return
        }

        const productParameters: ProductParameters[] = []
        for (let product of this.model.productModels) {
            if (!product.enabled) {
                continue
            }
            const services: ServiceParameters[] = []

            product.choosable.forEach(value => {
                services.push({
                    id: value
                })
            });

            product.serviceModels
                .filter(service => !service.service.optional || service.enabled)
                .forEach(service => services.push({
                    id: service.service.id,
                    imageTag: service.imageTag
                }))


            const parameters: ParameterValue[] = []
            product.parameterModels.forEach(parameter => {
                const value = parameter.parameter.inputType == 'checkbox' ? parameter.value.toString() : parameter.value
                parameters.push({
                    id: parameter.parameter.id,
                    value: value
                })
            })

            productParameters.push({
                id: product.product.id,
                imageTag: product.imageTag,
                services: services,
                parameters: parameters
            });

        }

        deployments.startDeployment({
            name: this.model.name,
            expiry: this.model.expiry,
            products: productParameters
        })
            .then(() => {
                this.$router.push("/")
                deployments.initNewDeployment()
            })
            .catch(error => {
                this.error = error
                this.message = error.data
            })
    }

    public cancelDeployment() {
        this.$router.push("/");
        deployments.initNewDeployment();
    }

    get model(): DeploymentModel {
        return deployments.newDeploymentModel;
    }
}
